/**
 * Point d'entrée unique pour PortfolioContext
 * Exporte le bon contexte selon le feature flag
 * Cela garantit que les composants utilisent toujours le même contexte que le provider
 */
import React from 'react';
import { FEATURES } from '../config/features';
import { PortfolioProvider as PortfolioProviderV2, usePortfolio as usePortfolioV2 } from './PortfolioContextV2';
import { PortfolioProvider as PortfolioProviderV1, usePortfolio as usePortfolioV1 } from './PortfolioContext';

// Wrapper pour éviter "Cannot access before initialization" au chargement du module (ternary évalué au render)
export function PortfolioProvider(props) {
  return FEATURES.USE_PORTFOLIO_V2
    ? React.createElement(PortfolioProviderV2, props)
    : React.createElement(PortfolioProviderV1, props);
}

// Hook : délégation à l'appel pour éviter TDZ. FEATURES.USE_PORTFOLIO_V2 est constant (build-time), donc un seul hook est appelé à chaque render.
/* eslint-disable react-hooks/rules-of-hooks */
export function usePortfolio() {
  if (FEATURES.USE_PORTFOLIO_V2) {
    return usePortfolioV2();
  }
  return usePortfolioV1();
}
/* eslint-enable react-hooks/rules-of-hooks */

